import axios from 'axios';
import Cookies from 'js-cookie';
import { getMessge } from './utils/messageCreator'
import { refresh, refreshErrorHandle } from "./refresh";
import { apiConfig } from '../config';

// ----------------------------------------------------------------------
const baseURL = apiConfig.API_URL


const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.response.use(
  (response) => (response.data),
  (error) => {
    console.log('error: ', error.response.data)
    if (error.response != null && error.response.data != null) {
      const { code } = error.response.data
      error.response.data.message = getMessge(code)
    }
    return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

axiosInstance.interceptors.request.use(refresh, refreshErrorHandle);

export default axiosInstance;
